import { Outlet } from '@tanstack/react-router';
import { Box, Group, Stack } from '#core/components';
import { useSyncTagsToStore } from '#domains/tags';
import { Header } from '../header';
import { MainNav } from '../main-nav/v2';
import { ErrorPage, LoaderPage } from '../pages';

import styles from './AppLayout.module.css';

export const AppLayout = () => {
  // This should be here instead of a router loader, because mutating tags
  // can happen in contexts where the route doesn't change.
  const { isError, isPending } = useSyncTagsToStore();

  if (isPending) {
    return <LoaderPage />;
  }

  if (isError) {
    return <ErrorPage />;
  }

  return (
    <Stack className={styles.app}>
      <Header />
      <Group flex={1}>
        <MainNav />
        <Box className={styles.main}>
          <Box className={styles.content}>
            <Outlet />
          </Box>
        </Box>
      </Group>
    </Stack>
  );
};
